<template>
  <div class="content-wrapper">
    <div class="content-box">
      <img
        src="@/assets/images/notices/error-banner.png"
        alt="error-banner"
        class="banner"
      />

      <div class="content-item">
        {{ $t("notices.keyword4") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword5") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword6") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword7") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword8") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword9") }}
      </div>
      <div class="content-item">
        {{ $t("notices.keyword10") }}
      </div>
    </div>
    <a class="join-group-button" href="https://filepax.com/drive/feedback">{{
      $t("notices.keyword11")
    }}</a>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = this.$t("notices.keyword1");
  },
};
</script>

<style lang="less" scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  height: 100vh;

  .content-box {
    height: calc(100vh - 100px);
    overflow-y: scroll;
  }

  .banner {
    display: block;
    width: 154px;
    height: 110px;
    margin: 32px auto;
  }

  .content-item {
    font-size: 17px;
    padding: 0 16px;
    margin-bottom: 24px;
  }

  .join-group-button {
    position: fixed;
    bottom: 32px;
    width: calc(100vw - 32px);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 54px;
    background: #306eff;
    font-size: 17px;
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
  }

  .date-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 16px;
  }
}
</style>
